import { Receipt } from "./model";

// EFTPOS "customer copy" 영수증 텍스트 생성.
// tabletious PsOrderServiceImpl.processCNPReceipt(카드주문 시 로컬 프린터로 찍는 부분)를 그대로 복제.
// 데이터는 서버 변경 없이 findReceiptByOrderId로 받은 Receipt를 그대로 사용한다.
export function buildCustomerCopy(r: any): string {
    const header = "==========================\n*** CUSTOMER COPY ***\n--------------------------\n";
    const footer = "--------------------------\n\nPLEASE RETAIN RECEIPT\nFOR YOUR RECORDS\n\n==========================";
    let when = r.transactionDate ?? "";
    try { if (r.transactionDate) when = new Date(r.transactionDate).toLocaleString(); } catch (e) { /* raw 유지 */ }
    const v = (x: any) => (x ?? "");
    // 값이 없는 줄은 아예 빼서 라벨만 남는 ": " · "Merchant ID: " 같은 빈 줄을 없앤다.
    // Till Hosted Page는 카드정보(cardType/cardNumber/cardCategory)·serviceId·rrn을 주지 않는다 —
    // 카드 데이터를 우리 시스템 밖에 두는 게 그 방식의 핵심이라 빈 값이 정상이다.
    // UrPay 영수증은 이 값들이 채워져 있어 출력이 그대로 유지된다.
    const has = (x: any) => x !== null && x !== undefined && String(x).trim() !== "";
    const line = (label: string, x: any) => (has(x) ? label + String(x) + "\n" : "");
    // "$0.39" 처럼 통화기호가 붙어 올 수 있다(tabletious convertDollarStrToBigDecimal과 같은 처리).
    const money = (x: any) => {
        const n = parseFloat(String(v(x)).replace(/[$,]/g, ""));
        return isNaN(n) ? 0 : n;
    };

    let body = when + "\n";
    body += line("Merchant ID: ", r.serviceId);
    body += "\nPurchase Transaction\n";
    body += "Amount: " + v(r.originalAmount) + "\n";
    // 서차지 0은 알릴 내용이 없다(2026-10-01 카드 서차지 폐지 후엔 항상 0). 안내 문구도 부과할 때만.
    if (money(r.surchargeAmount) > 0) {
        body += "Surcharge: " + v(r.surchargeAmount) + "\n";
        body += line("Surcharge Description: ", r.surchargeAmountDescription);
    }
    body += "Total: " + v(r.total) + "\n";
    if (has(r.cardType) || has(r.cardNumber)) {
        body += v(r.cardType) + ": " + v(r.cardNumber) + "\n";
    }
    body += line("", r.cardCategory);
    body += "\n" + v(r.message) + "\n";
    body += "Reference: " + v(r.reference) + "\n";
    body += "Auth Code: " + v(r.authorization) + "\n";
    body += "TxID: " + v(r.transactionId) + "\n";
    body += line("RRN: ", r.rrn);
    return header + body + footer;
}

// 서버가 카드 결제가 아니면 빈 객체({})를 줄 수 있다. 렌더 가치가 있는 영수증인지 판정.
export function hasReceipt(r: Receipt | null | undefined): boolean {
    return !!r && Object.keys(r).length > 0;
}
